import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.selectElement = this.element.querySelector('select[data-select-target="select"]');
    if (this.selectElement) {
      // Disable SelectComponent's form submission by removing its name
      this.originalName = this.selectElement.name;
      this.selectElement.removeAttribute('name');
      
      this.selectElement.addEventListener('change', this.handleSelectionChange.bind(this));
      this.handleSelectionChange();
    }
  }

  disconnect() {
    if (this.selectElement) {
      this.selectElement.removeEventListener('change', this.handleSelectionChange.bind(this));
    }
  }

  handleSelectionChange() {
    if (!this.selectElement) return;

    // Build full asset objects from selected options
    const selectedAssets = Array.from(this.selectElement.selectedOptions).map(option => {
      const selectControllerElement = this.selectElement.closest('[data-controller*="select"]');
      const selectController = this.application.getControllerForElementAndIdentifier(selectControllerElement, "select");
      
      if (selectController && selectController.select) {
        const tomSelectData = selectController.select.options[option.value];
        return {
          id: parseInt(option.value),
          name: tomSelectData?.name || option.textContent,
          url: `/assets/${option.value}`,
          company_name: tomSelectData?.company_name,
          asset_type: tomSelectData?.asset_type
        };
      } else {
        return {
          id: parseInt(option.value),
          name: option.textContent,
          url: `/assets/${option.value}`
        };
      }
    });
    
    // Create/update hidden field with JSON
    let hiddenField = this.element.querySelector('input[type="hidden"][name="' + this.originalName.replace('[]', '') + '"]');
    if (!hiddenField) {
      hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = this.originalName.replace('[]', ''); // data instead of data[]
      this.element.appendChild(hiddenField);
    }

    hiddenField.value = JSON.stringify(selectedAssets.map(a => ({
      id: a.id,
      name: a.name,
      url: a.url
    })));
  }
}